/* eslint no-param-reassign: 0 */ // --> OFF
import moment from 'moment';
import {
  fieldTypes,
  filterConditions,
  GENERAL_FILTER_FIELD
} from './filter-utils';

const filterAdapter = Object.freeze({
  [fieldTypes.STRING]: {
    filterToParam: (value, column) => {
      return column.filterCondition === filterConditions.LIKE
        ? `%${value}%`
        : value;
    },
    symbols: {
      [filterConditions.LIKE]: 'ilike',
      [filterConditions.EQUALS]: 'eq',
      [filterConditions.NOT_EQUALS]: 'ne'
    }
  },
  [fieldTypes.NUMERIC]: {
    filterToParam: (value) => value,
    symbols: {
      [filterConditions.LT]: 'lt',
      [filterConditions.EQUALS]: 'eq',
      [filterConditions.GT]: 'gt'
    }
  },
  [fieldTypes.DATE]: {
    filterToParam: (value) => {
      if (moment.isMoment(value)) {
        return value.format('YYYY-MM-DD');
      }
      return value;
    },
    symbols: {
      [filterConditions.LT]: 'lt',
      [filterConditions.EQUALS]: 'eq',
      [filterConditions.GT]: 'gt'
    }
  },
  [fieldTypes.DATE_RANGE]: {
    filterToParam: (value) => {
      let desde;
      let hasta;
      if (value[0]) {
        desde = moment(value[0], 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
      if (value[1]) {
        hasta = moment(value[1], 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
      return [desde, hasta];
    },
    symbols: {
      [filterConditions.BETWEEN]: 'between'
    }
  },
  [fieldTypes.DATETIME]: {
    filterToParam: (value) => {
      if (moment.isMoment(value)) {
        return value.format('YYYY-MM-DD');
      }
      return value;
    },
    symbols: {
      [filterConditions.LT]: 'lt',
      [filterConditions.EQUALS]: 'eq',
      [filterConditions.GT]: 'gt'
    }
  },
  [fieldTypes.BOOLEAN]: {
    filterToParam: (value) => value,
    symbols: {
      [filterConditions.EQUALS]: 'eq'
    }
  },
  [fieldTypes.ENUM]: {
    filterToParam: (value) => value,
    symbols: {
      [filterConditions.IN]: 'in'
    }
  },
  [fieldTypes.OBJECT]: {
    filterToParam: (value, column) => {
      // If filter settings defines a function for converting the filter value to param, use that
      if (column.settings && column.settings.optionToParam) {
        return column.settings.optionToParam(column.value);
      }
      // Otherwise use the value id
      return value && value.id;
    },
    symbols: {
      [filterConditions.EQUALS]: 'eq'
    }
  }
});

const SORT_VALUES = {
  ascend: 'ASC',
  descend: 'DESC'
};

export const toRequestParams = (filters, pagination, sorters, columnsMap) => {
  if (!Array.isArray(sorters) && sorters && Object.keys(sorters).length > 0) {
    sorters = [sorters];
  } else if (!Array.isArray(sorters)) {
    sorters = [];
  }

  const orderParams = sorters.reduce((params, sorter) => {
    if (sorter.order && sorter.column) {
      let { key } = sorter.column;
      if (!key) {
        if (Array.isArray(sorter.column.dataIndex)) {
          key = sorter.column.dataIndex.join('.');
        } else {
          key = sorter.column.dataIndex;
        }
      }

      params[`orderBy__${key}`] = SORT_VALUES[sorter.order];
    }

    return params;
  }, {});

  const pagerParams = {
    page: pagination.current,
    pageSize: pagination.pageSize
  };

  const filterParams = Object.keys(filters).reduce((params, filter) => {
    if (filter === GENERAL_FILTER_FIELD) {
      params.all = filters[filter];
    } else if (filters[filter] !== null && filters[filter] !== undefined) {
      const searchKey =
        (columnsMap[filter].searchKey && `.${columnsMap[filter].searchKey}`) ||
        '';
      params[
        `by__${filter}${searchKey}-${
          filterAdapter[columnsMap[filter].filterType].symbols[
            columnsMap[filter].filterCondition
          ]
        }`
      ] = filterAdapter[columnsMap[filter].filterType].filterToParam(
        filters[filter],
        columnsMap[filter]
      );
    }
    return params;
  }, {});

  return { ...orderParams, ...pagerParams, ...filterParams };
};

export default toRequestParams;
